import config from 'init/config';
import { fRequest } from 'utilities/api';

export const api_orderAgain = orderId =>
  fRequest(`${config.buckRootUrl}/api/order/${orderId}/order-again/`, {
    method: 'POST'
  });
